import React, { useEffect, useState } from 'react'
import { CustomModal, InputText, Btn } from '../../../../components'
import { saveRoteirizacaoPrevia } from '../../../../services/api/https/deliveries/roteirizacao-previa.http'
import { errorHandler } from '../../../../services/util/error.service'

const ModalRoteirizacaoPrevia = ({ show, roteirizacao, onResponse }) => {
  // Hooks
  const [rot, setRot] = useState(roteirizacao)
  useEffect(() => {
    roteirizacao && setRot(roteirizacao)
  }, [roteirizacao])
  // Events
  const onBtnSalvarClicked = async () => {
    try {
      if (rot.name.trim().length === 0) {
        onResponse('error', 'Descrição Incorreta')
      } else {
        const savedRoteirizacao = await saveRoteirizacaoPrevia(rot)
        onResponse('success', savedRoteirizacao)
      }
    } catch (error) {
      onResponse('error', errorHandler(error))
    }
  }
  // Render
  return (
    <CustomModal header="Roteirização Prévia" isVisible={show} onClose={() => onResponse('close')}>
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Descrição :"
            marginTop={10}
            value={rot.name}
            onChange={value => setRot({ ...rot, name: value })}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default ModalRoteirizacaoPrevia
